import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "details deals__container deals__container--active" }
const _hoisted_2 = { class: "details-filter" }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = {
  class: "form",
  id: "details-form"
}
const _hoisted_5 = { class: "form-block form-block--25" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "form-block form-block--25" }
const _hoisted_8 = { class: "form-block form-block--25" }
const _hoisted_9 = { class: "pay-method" }
const _hoisted_10 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_11 = { class: "form-block form-block--25" }
const _hoisted_12 = { class: "form-block form-block--25" }
const _hoisted_13 = { class: "form-block form-block--25" }
const _hoisted_14 = { class: "form-block form-block--25" }
const _hoisted_15 = { class: "form__controls" }
const _hoisted_16 = { class: "text-capitalize-first" }
const _hoisted_17 = { class: "text-capitalize-first" }
const _hoisted_18 = { class: "details__controls" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first limits-label" }
const _hoisted_22 = {
  key: 0,
  class: "limits-dot",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = {
  class: "mb-2 d-flex align-items-center flex-wrap",
  style: {"gap":"12px"}
}
const _hoisted_26 = { class: "form__btn form__btn--reset btn btn--2 requisites-per-page" }
const _hoisted_27 = { class: "text-capitalize-first" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "text-capitalize-first" }
const _hoisted_31 = { class: "d-flex align-items-center gap-2 mb-0" }
const _hoisted_32 = ["checked"]
const _hoisted_33 = { class: "text-capitalize-first" }
const _hoisted_34 = { class: "text-capitalize-first" }
const _hoisted_35 = { class: "text-capitalize-first" }
const _hoisted_36 = { class: "text-capitalize-first" }
const _hoisted_37 = {
  key: 0,
  class: "d-flex flex-wrap gap-3 requisites-legend"
}
const _hoisted_38 = { style: {"overflow":"auto"} }
const _hoisted_39 = {
  class: "table table__flex",
  style: {"position":"relative"}
}
const _hoisted_40 = {
  key: 0,
  class: "requisites-drag-cell"
}
const _hoisted_41 = { style: {"text-align":"left"} }
const _hoisted_42 = { class: "text-capitalize-first" }
const _hoisted_43 = { style: {"width":"0"} }
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = { style: {"width":"0"} }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { style: {} }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { style: {} }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { style: {} }
const _hoisted_52 = { class: "text-capitalize-first" }
const _hoisted_53 = { style: {} }
const _hoisted_54 = { class: "text-capitalize-first" }
const _hoisted_55 = { style: {} }
const _hoisted_56 = { class: "text-capitalize-first" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 0,
  class: "requisites-drag-cell"
}
const _hoisted_59 = { class: "detail__card card-info" }
const _hoisted_60 = { class: "d-flex align-items-center gap-sm" }
const _hoisted_61 = ["checked", "onChange"]
const _hoisted_62 = { class: "card-info__title" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "card-info__name" }
const _hoisted_66 = { class: "card-info__number" }
const _hoisted_67 = { class: "card-info__name" }
const _hoisted_68 = { class: "card-info__number d-flex align-items-start gap-1 flex-wrap" }
const _hoisted_69 = ["href"]
const _hoisted_70 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_71 = ["href"]
const _hoisted_72 = ["href"]
const _hoisted_73 = ["title"]
const _hoisted_74 = ["title"]
const _hoisted_75 = ["title"]
const _hoisted_76 = { key: 7 }
const _hoisted_77 = { class: "card-info__name" }
const _hoisted_78 = { class: "detail__flex" }
const _hoisted_79 = { class: "rate-info__mobile-label" }
const _hoisted_80 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_81 = ["src"]
const _hoisted_82 = { class: "detail__flex" }
const _hoisted_83 = { class: "rate-info__mobile-label" }
const _hoisted_84 = { class: "detail__flex" }
const _hoisted_85 = { class: "rate-info__mobile-label" }
const _hoisted_86 = { class: "sum-limits" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "detail__limits" }
const _hoisted_90 = { class: "rate-info__mobile-label" }
const _hoisted_91 = { class: "detail__limit" }
const _hoisted_92 = { class: "detail__limit-type" }
const _hoisted_93 = ["title"]
const _hoisted_94 = { class: "limits-values" }
const _hoisted_95 = { class: "detail__limit" }
const _hoisted_96 = { class: "detail__limit-type" }
const _hoisted_97 = ["title"]
const _hoisted_98 = { class: "limits-values" }
const _hoisted_99 = { class: "detail__limits count-limits" }
const _hoisted_100 = { class: "rate-info__mobile-label" }
const _hoisted_101 = { class: "detail__limit" }
const _hoisted_102 = { class: "detail__limit-type" }
const _hoisted_103 = ["title"]
const _hoisted_104 = { class: "limits-values" }
const _hoisted_105 = { class: "detail__limit" }
const _hoisted_106 = { class: "detail__limit-type" }
const _hoisted_107 = ["title"]
const _hoisted_108 = { class: "limits-values" }
const _hoisted_109 = { class: "detail__flex" }
const _hoisted_110 = { class: "rate-info__mobile-label" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "detail__flex" }
const _hoisted_113 = { class: "rate-info__mobile-label" }
const _hoisted_114 = { class: "switcher" }
const _hoisted_115 = { class: "switch" }
const _hoisted_116 = ["title", "onUpdate:modelValue", "onChange"]
const _hoisted_117 = {
  class: "detail__controls",
  style: {}
}
const _hoisted_118 = ["onClick"]
const _hoisted_119 = ["onClick", "title"]
const _hoisted_120 = ["onClick"]
const _hoisted_121 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_RequisitesPhoneGroupRow = _resolveComponent("RequisitesPhoneGroupRow")!
  const _component_RequisiteRow = _resolveComponent("RequisiteRow")!
  const _component_RequisiteFillStatusDot = _resolveComponent("RequisiteFillStatusDot")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_ReuseMinCapBadge = _resolveComponent("ReuseMinCapBadge")!
  const _component_RequisiteSumFill = _resolveComponent("RequisiteSumFill")!
  const _component_Sortable = _resolveComponent("Sortable")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_RequisiteTemplatesPopup = _resolveComponent("RequisiteTemplatesPopup")!
  const _component_RequisiteFormPopup = _resolveComponent("RequisiteFormPopup")!
  const _component_CounterpartiesPopup = _resolveComponent("CounterpartiesPopup")!
  const _component_BlacklistMethodAgreementPopup = _resolveComponent("BlacklistMethodAgreementPopup")!
  const _component_RequisitesGroupsPopup = _resolveComponent("RequisitesGroupsPopup")!
  const _component_DevicesPopup = _resolveComponent("DevicesPopup")!
  const _component_DeviceLogsPopup = _resolveComponent("DeviceLogsPopup")!
  const _component_LimitsPopup = _resolveComponent("LimitsPopup")!
  const _component_RequisitesBulkEditPopup = _resolveComponent("RequisitesBulkEditPopup")!
  const _component_FraudexCheckPopup = _resolveComponent("FraudexCheckPopup")!
  const _component_FraudexFeedbackPopup = _resolveComponent("FraudexFeedbackPopup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event)),
              placeholder: _ctx.$t('labels.sanitized_requisite'),
              class: "form-control"
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.requestDTO.query]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Multiselect, {
              id: "currencies",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.currencies,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
              options: _ctx.currencyList,
              "custom-label": (opt) => `${opt}`,
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.$t('labels.currencies')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Multiselect, {
              id: "methods",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.methods,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
              options: _ctx.methodList(),
              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_methods')
            }, {
              option: _withCtx((props) => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_PayMethodIcon, {
                    "icon-class": "icon",
                    method: props.option
                  }, null, 8, ["method"]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Multiselect, {
              id: "options",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.options,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
              options: _ctx.store.getters['currencyMethods/options'](),
              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_options')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Multiselect, {
              id: "statused",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.statuses,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
              options: [1, 0],
              "custom-label": (opt) => opt === 1 ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive'),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.status')
            }, null, 8, ["modelValue", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Multiselect, {
              id: "group",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.groupId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.groupId) = $event)),
              options: _ctx.store.getters['reqGroups/ids'],
              "custom-label": (opt) => _ctx.store.getters['reqGroups/get'](opt)?.name,
              multiple: false,
              "select-label": "Select",
              placeholder: _ctx.$t('labels.req_group')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Multiselect, {
              id: "device",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.deviceId,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.deviceId) = $event)),
              options: _ctx.store.getters['devices/ids'],
              "custom-label": (opt) => _ctx.store.getters['devices/get'](opt)?.name,
              multiple: false,
              "select-label": "Select",
              placeholder: _ctx.$t('labels.device')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.applyFilters,
              class: "form__btn btn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('button.apply')), 1)
              ]),
              _: 1
            }, 8, ["on-click"]),
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.clearFilters,
              class: "form__btn form__btn--reset btn btn--2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('button.reset')), 1)
              ]),
              _: 1
            }, 8, ["on-click"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.showDevices()), ["prevent"])),
        class: "form__btn form__btn--reset btn btn--2"
      }, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('labels.devices')), 1),
        _cache[25] || (_cache[25] = _createElementVNode("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", { d: "M8 16.25C8 16.0511 8.07902 15.8603 8.21967 15.7197C8.36032 15.579 8.55109 15.5 8.75 15.5H11.25C11.4489 15.5 11.6397 15.579 11.7803 15.7197C11.921 15.8603 12 16.0511 12 16.25C12 16.4489 11.921 16.6397 11.7803 16.7803C11.6397 16.921 11.4489 17 11.25 17H8.75C8.55109 17 8.36032 16.921 8.21967 16.7803C8.07902 16.6397 8 16.4489 8 16.25Z" }),
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4 4C4 3.20435 4.31607 2.44129 4.87868 1.87868C5.44129 1.31607 6.20435 1 7 1H13C13.7956 1 14.5587 1.31607 15.1213 1.87868C15.6839 2.44129 16 3.20435 16 4V16C16 16.7956 15.6839 17.5587 15.1213 18.1213C14.5587 18.6839 13.7956 19 13 19H7C6.20435 19 5.44129 18.6839 4.87868 18.1213C4.31607 17.5587 4 16.7956 4 16V4ZM8 2.5V3.25C8 3.664 8.336 4 8.75 4H11.25C11.4489 4 11.6397 3.92098 11.7803 3.78033C11.921 3.63968 12 3.44891 12 3.25V2.5H13C13.3978 2.5 13.7794 2.65804 14.0607 2.93934C14.342 3.22064 14.5 3.60218 14.5 4V16C14.5 16.3978 14.342 16.7794 14.0607 17.0607C13.7794 17.342 13.3978 17.5 13 17.5H7C6.60218 17.5 6.22064 17.342 5.93934 17.0607C5.65804 16.7794 5.5 16.3978 5.5 16V4C5.5 3.60218 5.65804 3.22064 5.93934 2.93934C6.22064 2.65804 6.60218 2.5 7 2.5H8Z"
          })
        ], -1))
      ]),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.showGroups()), ["prevent"])),
        class: "form__btn form__btn--reset btn btn--2"
      }, [
        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('button.groups')), 1)
      ]),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showLimits()), ["prevent"])),
        class: "form__btn form__btn--reset btn btn--2"
      }, [
        _createElementVNode("span", _hoisted_21, [
          _createTextVNode(_toDisplayString(_ctx.$t('button.limits')) + " ", 1),
          (_ctx.hasUnfinishedPlans)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.templatesAvailable)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showTemplates()), ["prevent"])),
            class: "form__btn form__btn--reset btn btn--2"
          }, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('requisites.templates.button')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.showEditForm()), ["prevent"])),
        href: "#",
        class: "form__btn form__btn--reset btn btn--2"
      }, [
        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('button.create')), 1)
      ])
    ]),
    _createVNode(_component_LoaderContent, { ref: "loader" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('labels.show')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requisites.limit) = $event)),
              class: "requisites-per-page__select",
              onChange: _cache[14] || (_cache[14] = ($event: any) => {_ctx.page = 1; _ctx.load()})
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perPageOptions, (opt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: opt,
                  value: opt
                }, _toDisplayString(opt), 9, _hoisted_28))
              }), 128))
            ], 544), [
              [
                _vModelSelect,
                _ctx.requisites.limit,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('labels.records')), 1)
          ]),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleGroupByPhone && _ctx.toggleGroupByPhone(...args)), ["prevent"])),
            class: _normalizeClass(["form__btn form__btn--reset btn btn--2", {'btn--accept': _ctx.groupByPhone}])
          }, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('requisites.group_by_phone')), 1)
          ], 2),
          (_ctx.bulkEditAvailable)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("label", _hoisted_31, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input mt-0",
                    checked: _ctx.allVisibleSelected,
                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectAllVisible($event.target.checked)))
                  }, null, 40, _hoisted_32),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('requisites.select_all_page')), 1)
                ]),
                (_ctx.selectedItems.length > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showBulkEdit && _ctx.showBulkEdit(...args)), ["prevent"])),
                      class: "form__btn form__btn--reset btn btn--2"
                    }, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('requisites.bulk_edit_selected', {count: _ctx.selectedItems.length})), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.groupByPhone)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.selectedInactiveItems.length > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.enableSelected && _ctx.enableSelected(...args)), ["prevent"])),
                      class: "form__btn form__btn--reset btn btn--2"
                    }, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('requisites.enable_selected', {count: _ctx.selectedInactiveItems.length})), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedActiveItems.length > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "#",
                      onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disableSelected && _ctx.disableSelected(...args)), ["prevent"])),
                      class: "form__btn form__btn--reset btn btn--2"
                    }, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('requisites.disable_selected', {count: _ctx.selectedActiveItems.length})), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.hasFrozenRequisites)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['free', 'in_progress', 'near_limit', 'limit', 'inactive'], (status) => {
                return _createElementVNode("span", {
                  key: status,
                  class: "d-inline-flex align-items-center gap-1"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["requisite-status-dot", 'requisite-status-dot--' + status])
                  }, null, 2),
                  _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites.status_' + status)), 1)
                ])
              }), 64))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("table", _hoisted_39, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (!_ctx.groupByPhone && _ctx.reorderEnabled)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_40))
                  : _createCommentVNode("", true),
                _createElementVNode("th", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('labels.requisites')), 1)
                ]),
                _createElementVNode("th", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('labels.device')), 1)
                ]),
                _createElementVNode("th", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('labels.req_group')), 1)
                ]),
                _createElementVNode("th", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('labels.sum_limits')), 1)
                ]),
                _createElementVNode("th", _hoisted_49, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('labels.volume_limits')), 1)
                ]),
                _createElementVNode("th", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('labels.count_limits')), 1)
                ]),
                _createElementVNode("th", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('labels.concurrent_trader_count_short')), 1)
                ]),
                _createElementVNode("th", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('labels.status')), 1)
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("th", null, null, -1))
              ])
            ]),
            (_ctx.groupByPhone)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: group.key ?? group.items[0].id
                    }, [
                      (group.key !== null)
                        ? (_openBlock(), _createBlock(_component_RequisitesPhoneGroupRow, {
                            key: 0,
                            group: group,
                            expanded: _ctx.isExpanded(group),
                            "selected-count": _ctx.selectedCountInGroup(group),
                            onToggleExpand: ($event: any) => (_ctx.toggleExpand(group)),
                            onSelect: checked => _ctx.selectGroup(group, checked)
                          }, null, 8, ["group", "expanded", "selected-count", "onToggleExpand", "onSelect"]))
                        : _createCommentVNode("", true),
                      (group.key === null)
                        ? (_openBlock(), _createBlock(_component_RequisiteRow, {
                            key: 1,
                            item: group.items[0],
                            selectable: "",
                            selected: _ctx.isSelected(group.items[0].id),
                            onSelect: checked => _ctx.toggleSelect(group.items[0], checked),
                            onToggle: _ctx.toggleRequisitesActivity,
                            onShowLogs: _ctx.showLogs,
                            onFraudexFeedback: _ctx.showFraudexFeedbackModal,
                            onEdit: _ctx.showEditForm,
                            onRemove: _ctx.deleteRequisites
                          }, null, 8, ["item", "selected", "onSelect", "onToggle", "onShowLogs", "onFraudexFeedback", "onEdit", "onRemove"]))
                        : _createCommentVNode("", true),
                      (group.key !== null && _ctx.isExpanded(group))
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(group.items, (item) => {
                            return (_openBlock(), _createBlock(_component_RequisiteRow, {
                              key: item.id,
                              item: item,
                              child: "",
                              selectable: "",
                              selected: _ctx.isSelected(item.id),
                              onSelect: checked => _ctx.toggleSelect(item, checked),
                              onToggle: _ctx.toggleRequisitesActivity,
                              onShowLogs: _ctx.showLogs,
                              onFraudexFeedback: _ctx.showFraudexFeedbackModal,
                              onEdit: _ctx.showEditForm,
                              onRemove: _ctx.deleteRequisites
                            }, null, 8, ["item", "selected", "onSelect", "onToggle", "onShowLogs", "onFraudexFeedback", "onEdit", "onRemove"]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_Sortable, {
                  key: 1,
                  list: _ctx.requisites.items,
                  "item-key": "id",
                  tag: "tbody",
                  onEnd: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onRequisitesReorder($event))),
                  options: {draggable: '.draggable', handle: '.drag-handle', forceFallback: true, fallbackOnBody: true, animation: 150, disabled: !_ctx.reorderEnabled}
                }, {
                  item: _withCtx(({element: item}) => [
                    (_openBlock(), _createElementBlock("tr", {
                      class: "draggable",
                      key: item.id
                    }, [
                      (_ctx.reorderEnabled)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_58, _cache[27] || (_cache[27] = [
                            _createElementVNode("div", { class: "drag-handle" }, [
                              _createElementVNode("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("circle", {
                                  cx: "5",
                                  cy: "3",
                                  r: "1.25",
                                  fill: "currentColor"
                                }),
                                _createElementVNode("circle", {
                                  cx: "11",
                                  cy: "3",
                                  r: "1.25",
                                  fill: "currentColor"
                                }),
                                _createElementVNode("circle", {
                                  cx: "5",
                                  cy: "8",
                                  r: "1.25",
                                  fill: "currentColor"
                                }),
                                _createElementVNode("circle", {
                                  cx: "11",
                                  cy: "8",
                                  r: "1.25",
                                  fill: "currentColor"
                                }),
                                _createElementVNode("circle", {
                                  cx: "5",
                                  cy: "13",
                                  r: "1.25",
                                  fill: "currentColor"
                                }),
                                _createElementVNode("circle", {
                                  cx: "11",
                                  cy: "13",
                                  r: "1.25",
                                  fill: "currentColor"
                                })
                              ])
                            ], -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            (_ctx.bulkEditAvailable)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "checkbox",
                                  class: "form-check-input flex-shrink-0",
                                  checked: _ctx.isSelected(item.id),
                                  onChange: ($event: any) => (_ctx.toggleSelect(item, $event.target.checked))
                                }, null, 40, _hoisted_61))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createVNode(_component_PayMethodIcon, {
                                "icon-class": "pay-method-icon-xl",
                                method: item.method
                              }, null, 8, ["method"])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("strong", null, _toDisplayString(item.currency), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t(`payment_options.${item.paymentOption}`)) + " ", 1),
                                  (item.crossBorderCurrency)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(item.crossBorderCurrency), 1))
                                    : _createCommentVNode("", true),
                                  _cache[28] || (_cache[28] = _createTextVNode()),
                                  (item.paymentSystem)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.helper.trans('payment_systems.' + item.paymentSystem)), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.crossBorderSwift(item.raw))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_65, _toDisplayString(item.holderName), 1),
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("span", null, _toDisplayString(item.requisites), 1),
                                      (_ctx.hasFrozenSums(item))
                                        ? (_openBlock(), _createBlock(_component_RequisiteFillStatusDot, {
                                            key: 0,
                                            item: item,
                                            class: "ms-1"
                                          }, null, 8, ["item"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('labels.raw_field.swift')) + " " + _toDisplayString(_ctx.crossBorderSwift(item.raw)), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_68, [
                                      (item.paymentOption === _ctx.PaymentOption.SBP_QR && item.requisites?.startsWith('http'))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: item.requisites,
                                            target: "_blank"
                                          }, _toDisplayString(_ctx.helper.domain(item.requisites)), 9, _hoisted_69))
                                        : (item.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_70, "—"))
                                          : (item.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && item.requisites.startsWith('http'))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                href: item.requisites,
                                                target: "_blank"
                                              }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_71))
                                            : (item.paymentOption === _ctx.PaymentOption.TIPS && item.requisites.startsWith('http'))
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 3,
                                                  href: item.requisites,
                                                  target: "_blank"
                                                }, _toDisplayString(_ctx.helper.domain(item.requisites)), 9, _hoisted_72))
                                              : (item.paymentOption === _ctx.PaymentOption.VIET_QR)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                                      class: "font-monospace text-break flex-grow-1",
                                                      style: {"min-width":"0"},
                                                      title: _ctx.vietQrEmvFromRaw(item.raw) || undefined
                                                    }, [
                                                      _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.vietQrEmvFromRaw(item.raw)) || '—'), 1)
                                                    ], 8, _hoisted_73)), [
                                                      [
                                                        _directive_b_tooltip,
                                                        void 0,
                                                        void 0,
                                                        { hover: true }
                                                      ]
                                                    ]),
                                                    (_ctx.vietQrEmvFromRaw(item.raw))
                                                      ? (_openBlock(), _createBlock(_component_copy_button, {
                                                          key: 0,
                                                          value: _ctx.vietQrEmvFromRaw(item.raw),
                                                          class: "flex-shrink-0 align-self-center"
                                                        }, null, 8, ["value"]))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                : (item.paymentOption === _ctx.PaymentOption.IND_QR)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                      _withDirectives((_openBlock(), _createElementBlock("span", {
                                                        class: "font-monospace text-break flex-grow-1",
                                                        style: {"min-width":"0"},
                                                        title: _ctx.qrisEmvFromRaw(item.raw) || undefined
                                                      }, [
                                                        _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.qrisEmvFromRaw(item.raw)) || '—'), 1)
                                                      ], 8, _hoisted_74)), [
                                                        [
                                                          _directive_b_tooltip,
                                                          void 0,
                                                          void 0,
                                                          { hover: true }
                                                        ]
                                                      ]),
                                                      (_ctx.qrisEmvFromRaw(item.raw))
                                                        ? (_openBlock(), _createBlock(_component_copy_button, {
                                                            key: 0,
                                                            value: _ctx.qrisEmvFromRaw(item.raw),
                                                            class: "flex-shrink-0 align-self-center"
                                                          }, null, 8, ["value"]))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  : (item.paymentOption === _ctx.PaymentOption.BR_QR)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                        _withDirectives((_openBlock(), _createElementBlock("span", {
                                                          class: "font-monospace text-break flex-grow-1",
                                                          style: {"min-width":"0"},
                                                          title: _ctx.pixEmvFromRaw(item.raw) || undefined
                                                        }, [
                                                          _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.pixEmvFromRaw(item.raw)) || '—'), 1)
                                                        ], 8, _hoisted_75)), [
                                                          [
                                                            _directive_b_tooltip,
                                                            void 0,
                                                            void 0,
                                                            { hover: true }
                                                          ]
                                                        ]),
                                                        (_ctx.pixEmvFromRaw(item.raw))
                                                          ? (_openBlock(), _createBlock(_component_copy_button, {
                                                              key: 0,
                                                              value: _ctx.pixEmvFromRaw(item.raw),
                                                              class: "flex-shrink-0 align-self-center"
                                                            }, null, 8, ["value"]))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(item.requisites), 1)),
                                      (_ctx.hasFrozenSums(item))
                                        ? (_openBlock(), _createBlock(_component_RequisiteFillStatusDot, {
                                            key: 8,
                                            item: item,
                                            class: "align-self-center ms-1"
                                          }, null, 8, ["item"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_77, _toDisplayString(item.holderName), 1)
                                  ], 64))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.$t('labels.device')), 1),
                        (item.device)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                              _createElementVNode("img", {
                                src: require(`@/apps/public/assets/img/device-${item.device.status}.svg`)
                              }, null, 8, _hoisted_81),
                              _createTextVNode(" " + _toDisplayString(item.device?.name), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('labels.req_group')), 1),
                        _createTextVNode(" " + _toDisplayString(item.group?.name), 1)
                      ]),
                      _createElementVNode("td", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('labels.sum_limits')), 1),
                        _createElementVNode("div", _hoisted_86, [
                          (item.minPayInDealSum)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.from_limit', {sum: _ctx.numberFormatter.formatNumber(item.minPayInDealSum), currency: item.minPayInDealSum!.currency })), 1),
                                _createVNode(_component_ReuseMinCapBadge, { item: item }, null, 8, ["item"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.maxPayInDealSum)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.helper.trans('labels.to_limit', {sum: _ctx.numberFormatter.formatNumber(item.maxPayInDealSum), currency: item.maxPayInDealSum!.currency })), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t('labels.volume_limits')), 1),
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('labels.day')), 1),
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: "detail__limit-container",
                              title: _ctx.sumTitle('labels.day', item.dayTradesSum, item.dayTradesFrozenSum)
                            }, [
                              (_ctx.hasFrozenSums(item))
                                ? (_openBlock(), _createBlock(_component_RequisiteSumFill, {
                                    key: 0,
                                    total: item.dayTradesSum,
                                    frozen: item.dayTradesFrozenSum,
                                    limit: item.dayTradesSumLimit,
                                    active: item.isActive
                                  }, null, 8, ["total", "frozen", "limit", "active"]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["detail__limit-count", {'bg-attention': _ctx.isDayLimitReached(item)}]),
                                    style: _normalizeStyle({width: (parseInt(item.dayTradesSum.amount)/parseInt(item.dayTradesSumLimit.amount) * 100) + '%'})
                                  }, null, 6)),
                              _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesSumLimit)), 1)
                            ], 8, _hoisted_93)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t('labels.month')), 1),
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: "detail__limit-container",
                              title: _ctx.sumTitle('labels.month', item.monthTradesSum, item.monthTradesFrozenSum)
                            }, [
                              (_ctx.hasFrozenSums(item))
                                ? (_openBlock(), _createBlock(_component_RequisiteSumFill, {
                                    key: 0,
                                    total: item.monthTradesSum,
                                    frozen: item.monthTradesFrozenSum,
                                    limit: item.monthTradesSumLimit,
                                    active: item.isActive
                                  }, null, 8, ["total", "frozen", "limit", "active"]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["detail__limit-count", {'bg-attention': _ctx.isMonthLimitReached(item)}]),
                                    style: _normalizeStyle({width: (parseInt(item.monthTradesSum.amount)/parseInt(item.monthTradesSumLimit.amount) * 100) + '%'})
                                  }, null, 6)),
                              _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesSumLimit)), 1)
                            ], 8, _hoisted_97)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t('labels.count_limits')), 1),
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.$t('labels.day')), 1),
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: "detail__limit-container",
                              title: _ctx.$t('labels.day')
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["detail__limit-count", {'bg-attention': item.dayTradesCountLimit > 0 && item.dayTradesCount/item.dayTradesCountLimit >= 0.9}]),
                                style: _normalizeStyle({width: (item.dayTradesCountLimit === 0 ? 0 : parseInt(item.dayTradesCount)/parseInt(item.dayTradesCountLimit) * 100) + '%'})
                              }, null, 6),
                              _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesCount)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesCountLimit)), 1)
                            ], 8, _hoisted_103)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t('labels.month')), 1),
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: "detail__limit-container",
                              title: _ctx.$t('labels.month')
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["detail__limit-count", {'bg-attention': item.monthTradesCountLimit > 0 && item.monthTradesCount/item.monthTradesCountLimit >= 0.9}]),
                                style: _normalizeStyle({width: (item.monthTradesCountLimit === 0 ? 0 : parseInt(item.monthTradesCount)/parseInt(item.monthTradesCountLimit) * 100) + '%'})
                              }, null, 6),
                              _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesCount)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesCountLimit)), 1)
                            ], 8, _hoisted_107)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_109, [
                        _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.$t('labels.concurrent_trader_count_short')), 1),
                        (item.concurrentTradesCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(_ctx.numberFormatter.formatNumber(item.concurrentTradesCount)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_112, [
                        _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.$t('labels.status')), 1),
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("label", _hoisted_115, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              title: item.isActive ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive'),
                              "onUpdate:modelValue": ($event: any) => ((item.isActive) = $event),
                              onChange: ($event: any) => (_ctx.toggleRequisitesActivity($event, item))
                            }, null, 40, _hoisted_116), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ],
                              [_vModelCheckbox, item.isActive]
                            ]),
                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "slider" }, null, -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_117, [
                          (item.device)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.showLogs(item.device)), ["prevent"]),
                                class: "btn detail__btn"
                              }, _cache[30] || (_cache[30] = [
                                _createElementVNode("svg", {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 20 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M3.505 2.365C5.32653 2.12142 7.16226 1.99948 9 2C10.863 2 12.697 2.124 14.495 2.365C15.742 2.532 16.675 3.473 16.93 4.633C16.7394 4.59745 16.5466 4.57441 16.353 4.564C14.7855 4.47838 13.2145 4.47838 11.647 4.564C9.229 4.696 7.5 6.727 7.5 8.998V11.238C7.5 12.651 8.17 13.973 9.26 14.8L6.28 17.78C6.17511 17.8848 6.04153 17.9561 5.89614 17.985C5.75074 18.0139 5.60004 17.999 5.46308 17.9423C5.32611 17.8856 5.20903 17.7895 5.12661 17.6663C5.04419 17.5431 5.00013 17.3982 5 17.25V13.807C4.499 13.759 4 13.701 3.505 13.635C2.033 13.438 1 12.162 1 10.72V5.28C1 3.839 2.033 2.562 3.505 2.365Z",
                                    fill: "#F7F9FC"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M14 6C13.238 6 12.48 6.02 11.729 6.062C10.157 6.148 9 7.472 9 8.998V11.238C9 12.757 10.147 14.077 11.71 14.173C11.924 14.186 12.138 14.197 12.352 14.207C12.552 14.216 12.737 14.297 12.87 14.431L15.22 16.781C15.3249 16.8858 15.4586 16.9572 15.6041 16.986C15.7496 17.0149 15.9004 16.9999 16.0374 16.9431C16.1744 16.8863 16.2915 16.7901 16.3738 16.6667C16.4562 16.5433 16.5001 16.3983 16.5 16.25V14.18C17.953 13.985 19 12.717 19 11.265V8.998C19 7.472 17.843 6.148 16.271 6.062C15.5147 6.02068 14.7574 6.00001 14 6Z",
                                    fill: "#F7F9FC"
                                  })
                                ], -1)
                              ]), 8, _hoisted_118))
                            : _createCommentVNode("", true),
                          (item.isWhiteTriangle && _ctx.store.getters.getAppData?.fraudexEnabled)
                            ? _withDirectives((_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.showFraudexFeedbackModal(item)), ["prevent"]),
                                title: _ctx.$t('fraudex.leave_feedback'),
                                class: "btn detail__btn"
                              }, [
                                _cache[31] || (_cache[31] = _createElementVNode("svg", {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 20 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M2 2C1.44772 2 1 2.44772 1 3V13C1 13.5523 1.44772 14 2 14H4V17.5858C4 17.851 4.10536 18.1054 4.29289 18.2929L7.70711 21.7071C7.89464 21.8946 8.149 22 8.41421 22H18C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H2Z",
                                    fill: "#F7F9FC"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7Z",
                                    fill: "white"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M5 10C5 9.44772 5.44772 9 6 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H6C5.44772 11 5 10.5523 5 10Z",
                                    fill: "white"
                                  })
                                ], -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('fraudex.leave_feedback')), 1)
                              ], 8, _hoisted_119)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.showEditForm(item)), ["prevent"]),
                            class: "btn detail__btn detail__redact"
                          }, _cache[32] || (_cache[32] = [
                            _createElementVNode("svg", {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M1.43302 17.9172L2.69502 14.7622C2.89605 14.2592 3.19714 13.8023 3.58002 13.4192L13.9898 3.01046L16.9903 6.01046L6.58102 16.4192C6.19799 16.8025 5.74108 17.1039 5.23802 17.3052L2.08302 18.5672C1.99216 18.6036 1.89262 18.6125 1.79674 18.5928C1.70087 18.5731 1.61287 18.5258 1.54366 18.4566C1.47446 18.3874 1.42708 18.2994 1.40742 18.2035C1.38775 18.1076 1.39665 18.0081 1.43302 17.9172Z",
                                fill: "#F7F9FC"
                              }),
                              _createElementVNode("path", {
                                d: "M18.1213 4.0012C18.1213 4.56381 17.8978 5.10338 17.5 5.5012L14.5 2.5012C14.8978 2.10338 15.4374 1.87988 16 1.87988C16.5626 1.87988 17.1022 2.10338 17.5 2.5012C17.8978 2.89903 18.1213 3.43859 18.1213 4.0012Z",
                                fill: "#F7F9FC"
                              })
                            ], -1)
                          ]), 8, _hoisted_120),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.deleteRequisites(item)), ["prevent"]),
                            class: "btn detail__btn detail__remove"
                          }, _cache[33] || (_cache[33] = [
                            _createElementVNode("svg", {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M2 3C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V5C1 5.26522 1.10536 5.51957 1.29289 5.70711C1.48043 5.89464 1.73478 6 2 6H18C18.2652 6 18.5196 5.89464 18.7071 5.70711C18.8946 5.51957 19 5.26522 19 5V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H2Z",
                                fill: "#F7F9FC"
                              }),
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7.22 9.22C7.36063 9.07955 7.55125 9.00066 7.75 9.00066C7.94875 9.00066 8.13937 9.07955 8.28 9.22L10 10.94L11.72 9.22C11.7887 9.14631 11.8715 9.08721 11.9635 9.04622C12.0555 9.00523 12.1548 8.98318 12.2555 8.98141C12.3562 8.97963 12.4562 8.99816 12.5496 9.03588C12.643 9.0736 12.7278 9.12974 12.799 9.20096C12.8703 9.27218 12.9264 9.35701 12.9641 9.4504C13.0018 9.54379 13.0204 9.64382 13.0186 9.74452C13.0168 9.84522 12.9948 9.94454 12.9538 10.0365C12.9128 10.1285 12.8537 10.2113 12.78 10.28L11.06 12L12.78 13.72C12.8537 13.7887 12.9128 13.8715 12.9538 13.9635C12.9948 14.0555 13.0168 14.1548 13.0186 14.2555C13.0204 14.3562 13.0018 14.4562 12.9641 14.5496C12.9264 14.643 12.8703 14.7278 12.799 14.799C12.7278 14.8703 12.643 14.9264 12.5496 14.9641C12.4562 15.0018 12.3562 15.0204 12.2555 15.0186C12.1548 15.0168 12.0555 14.9948 11.9635 14.9538C11.8715 14.9128 11.7887 14.8537 11.72 14.78L10 13.06L8.28 14.78C8.13783 14.9125 7.94978 14.9846 7.75548 14.9812C7.56118 14.9777 7.37579 14.899 7.23838 14.7616C7.10097 14.6242 7.02225 14.4388 7.01883 14.2445C7.0154 14.0502 7.08752 13.8622 7.22 13.72L8.94 12L7.22 10.28C7.07955 10.1394 7.00066 9.94875 7.00066 9.75C7.00066 9.55125 7.07955 9.36063 7.22 9.22Z",
                                fill: "#F7F9FC"
                              })
                            ], -1)
                          ]), 8, _hoisted_121)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["list", "options"]))
          ])
        ]),
        (_ctx.requisites.totalCount > (_ctx.groupByPhone ? _ctx.groups.length : _ctx.requisites.items.length))
          ? (_openBlock(), _createBlock(_component_b_pagination, {
              key: 1,
              style: {"margin-top":"40px"},
              modelValue: _ctx.page,
              "onUpdate:modelValue": [
                _cache[21] || (_cache[21] = ($event: any) => ((_ctx.page) = $event)),
                _cache[22] || (_cache[22] = ($event: any) => (_ctx.load()))
              ],
              "total-rows": _ctx.requisites.totalCount,
              "per-page": _ctx.requisites.limit,
              limit: 20,
              "prev-text": _ctx.$t('button.back'),
              "next-text": _ctx.$t('button.next'),
              align: "start",
              "first-number": "",
              "hide-goto-end-buttons": "",
              "hide-ellipsis": ""
            }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_ConfirmPopup, { ref: "confirmPopup" }, null, 512),
    (_ctx.templatesAvailable)
      ? (_openBlock(), _createBlock(_component_RequisiteTemplatesPopup, {
          key: 0,
          ref: "templatesPopup",
          onCreate: _ctx.createTemplate,
          onEdit: _ctx.editTemplate
        }, null, 8, ["onCreate", "onEdit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_RequisiteFormPopup, {
      ref: "requisitePopup",
      onUpdated: _ctx.handleRequisiteUpdated,
      onTemplateSaved: _ctx.onTemplateSaved,
      onShowCounterparties: _ctx.showCounterpartiesModal
    }, null, 8, ["onUpdated", "onTemplateSaved", "onShowCounterparties"]),
    _createVNode(_component_CounterpartiesPopup, { ref: "counterpartiesModal" }, null, 512),
    _createVNode(_component_BlacklistMethodAgreementPopup, {
      "onState:updated": _cache[23] || (_cache[23] = ($event: any) => (_ctx.onBlackListModalUpdated($event))),
      "onBulk:updated": _cache[24] || (_cache[24] = ($event: any) => (_ctx.onBulkAgreementUpdated($event))),
      ref: "agreementPopup"
    }, null, 512),
    _createVNode(_component_RequisitesGroupsPopup, { ref: "requisitesGroupsPopup" }, null, 512),
    _createVNode(_component_DevicesPopup, { ref: "devicesPopup" }, null, 512),
    _createVNode(_component_DeviceLogsPopup, { ref: "deviceLogsPopup" }, null, 512),
    _createVNode(_component_LimitsPopup, { ref: "limitsPopup" }, null, 512),
    _createVNode(_component_RequisitesBulkEditPopup, {
      ref: "bulkEditPopup",
      onUpdated: _ctx.onBulkEdited
    }, null, 8, ["onUpdated"]),
    (_ctx.store.getters.getAppData?.fraudexEnabled)
      ? (_openBlock(), _createBlock(_component_FraudexCheckPopup, {
          key: 1,
          ref: "fraudexCheckPopup",
          "fraudex-check": _ctx.fraudexCheckData?.fraudexCheck || null,
          onContinue: _ctx.handleFraudexCheckContinue,
          onCancel: _ctx.handleFraudexCheckCancel
        }, null, 8, ["fraudex-check", "onContinue", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.store.getters.getAppData?.fraudexEnabled)
      ? (_openBlock(), _createBlock(_component_FraudexFeedbackPopup, {
          key: 2,
          ref: "fraudexFeedbackPopup",
          requisite: _ctx.fraudexFeedbackRequisite?.requisites || '',
          onSubmit: _ctx.handleFraudexFeedbackSubmit
        }, null, 8, ["requisite", "onSubmit"]))
      : _createCommentVNode("", true)
  ]))
}